import React from "react";
import { WHATSAPP_URL } from "../../constants/contact";

export default function WhatsAppIcon() {
  return (
    <div className="fixed bottom-[40px] right-2 hover:scale-105 md:bottom-[85px]">
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/images/whatsapp-icon.png"
          className="w-12"
          alt="WhatsApp Chat"
        />
      </a>
    </div>
  );
}
